var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import icons from "../../utils/Icons";
import PrimaryButton from "../Button/PrimaryButton";
import { useDispatch, useSelector } from 'react-redux';
import { loginAsync } from '../../store/slices/userSlice';
import Spinner from "../Spinner";
import { ToastContainer, toast } from 'react-toastify';
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
var LoginModal = function (_a) {
    var closeModal = _a.closeModal, loginUser = _a.loginUser, openForgetPinModal = _a.openForgetPinModal;
    var dispatch = useDispatch();
    var isLoggedIn = useSelector(function (state) { return state.user.isLoggedIn; });
    var loading = useSelector(function (state) { return state.user.loading; });
    var errors = useSelector(function (state) { return state.user.errors; });
    var _b = useState(''), username = _b[0], setUsername = _b[1];
    var _c = useState(''), password = _c[0], setPassword = _c[1];
    var chaseListNavigate = useChaseListNavigate();
    var closeModalHandle = function () {
        closeModal();
    };
    var loginHandle = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(loginAsync({ email: username, pin: password }))];
                case 1:
                    response = _a.sent();
                    if (loginAsync.rejected.match(response)) {
                        // console.error(`error`, response.error);
                        toast.error('Login failed');
                    }
                    else {
                        // console.log(`success`, response.payload);
                        toast.success('Login successful');
                        loginUser();
                    }
                    console.log("response: ".concat(response));
                    loginUser();
                    return [2 /*return*/];
            }
        });
    }); };
    var pageChangeHandle = function (path) {
        chaseListNavigate(path);
    };
    var forgetPinModalHandle = function () {
        openForgetPinModal();
    };
    return (_jsxs("div", { className: "bg-[#1c1c1d99] absolute top-0 right-0 bottom-0 left-0 z-10 justify-center px-10", children: [_jsx(ToastContainer, { position: 'top-right' }), _jsxs("div", { className: "bg-white mt-20 relative w-full lg:w-[25%] lg:mx-auto rounded-xl border-slate-300 p-4 opacity-100", children: [_jsx("button", { onClick: function () { return closeModalHandle(); }, className: "text-slate-700 absolute top-[12px] right-[12px]", children: _jsx("img", { src: icons.closeBlack, alt: "" }) }), errors && _jsx("div", { className: "text-red-500 text-sm", children: Object.entries(errors).map(function (_a) {
                            var key = _a[0], value = _a[1];
                            return (_jsx("p", { children: value }, key));
                        }) }), _jsx("div", { className: "mt-2", children: _jsx("h3", { className: "text-left text-[18px] font-semibold", children: "Login" }) }), _jsxs("div", { className: "my-4 ", children: [_jsx("label", { htmlFor: "email", className: "mb-3 text-[15px] font-[500]", children: "Union number or Email" }), _jsx("input", { type: "email", className: "mt-[10px] w-full border borde-[#00000014] outline-none px-3 py-1 rounded-md", value: username, onChange: function (e) { return setUsername(e.target.value); }, placeholder: "Union Number or Email", onKeyDown: function (e) {
                                    var _a;
                                    if (e.key === 'Tab' || e.key === 'Enter') {
                                        e.preventDefault();
                                        (_a = document.getElementById('pin')) === null || _a === void 0 ? void 0 : _a.focus();
                                    }
                                } })] }), _jsxs("div", { className: "my-4 ", children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx("label", { htmlFor: "pin", className: "mb-3 text-[15px] font-[500]", children: "Pin" }), _jsx("button", { onClick: function () { return forgetPinModalHandle(); }, className: "text-[#5898FD] underline hidden", children: "Forget pin" })] }), _jsx("input", { type: "tel", pattern: "[0-9]*", id: "pin", inputMode: "numeric", className: "w-full border borde-slate-300 px-3 py-1 rounded-md", placeholder: "Enter Pin", value: password, onChange: function (e) {
                                    var value = e.target.value;
                                    if (/^\d*$/.test(value) && value.length <= 4) {
                                        setPassword(value);
                                    }
                                }, onKeyDown: function (e) {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        loginHandle();
                                    }
                                } })] }), _jsxs("div", { className: "my-4", children: [!loading && _jsx(PrimaryButton, { clickHandle: function () { return loginHandle(); }, title: "Login", classes: "text-white bg-[#5898FD] w-full py-2" }), loading && _jsx(Spinner, {}), _jsx(PrimaryButton, { clickHandle: function () {
                                    pageChangeHandle("/#/register");
                                    closeModal();
                                }, title: "Register an account", classes: "mt-3 text-[#5898FD] border border-[#5898FD] bg-white w-full py-2" })] })] })] }));
};
export default LoginModal;
